import React, { useCallback, useEffect, useState } from 'react';
import { fetchHostingAccount } from "src/actions/mine_craft/hostingActions";
import { useAppDispatch } from "src/store/hooks";
import { formattedDate } from "src/helpers/DateHelpers";

import { Button } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import Card from "src/componets/Card";
import AlertBlock from "src/componets/AlertBlock";

interface HostingAccount {
  id: string;
  name: string;
  webhookUrl: string | null;
  maxServers: number;
  activeServers: number;
  runningServers: number;
  createdAt: string;
}

// The crafty-servers account behind the platform's API key: quota,
// server counts and the registered webhook — also a quick "is the key
// valid" check.
const _Account = () => {
  const dispatch = useAppDispatch();

  const [account, setAccount] = useState<HostingAccount | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    const resultAction = await dispatch(fetchHostingAccount());
    setLoading(false);

    if (fetchHostingAccount.fulfilled.match(resultAction)) {
      setAccount(resultAction.payload);
    } else {
      const payload: any = resultAction.payload;
      setError(Array.isArray(payload) ? payload[0] : 'crafty-servers did not answer — check the API key');
    }
  }, [dispatch]);

  useEffect(() => {
    load().catch(console.error);
  }, [load]);

  return (
    <Card className='v-hosting-account'>
      <div className='o-head'>
        <h4 className='v-content-title'>Account</h4>
        <Button
          className='o-icon-btn'
          icon={<SyncOutlined />}
          title='Refresh'
          aria-label='Refresh account'
          loading={loading}
          onClick={() => load()}
        />
      </div>

      {error && <AlertBlock type='error' message={error} onClose={() => setError(null)} />}

      <div className='o-tiles'>
        <div className='o-tile'>
          <div className='o-value'>{account ? `${account.activeServers}/${account.maxServers}` : '-'}</div>
          <div className='o-label'>Servers used / quota</div>
        </div>
        <div className='o-tile'>
          <div className='o-value'>{account ? account.runningServers : '-'}</div>
          <div className='o-label'>Running now</div>
        </div>
      </div>

      {account &&
        <div className='o-rows'>
          <div className='o-row'>
            <span className='o-label'>Client</span>
            <span className='o-value'>{account.name} <span className='o-mono'>({account.id})</span></span>
          </div>
          <div className='o-row'>
            <span className='o-label'>Webhook</span>
            <span className='o-value o-mono'>{account.webhookUrl || 'not registered'}</span>
          </div>
          {account.createdAt &&
            <div className='o-row'>
              <span className='o-label'>Since</span>
              <span className='o-value'>{formattedDate(account.createdAt).dateTime}</span>
            </div>}
        </div>
      }
    </Card>
  );
}

export default _Account;
